import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { ScheduleEvent, ScheduleQuickstartContext, ScheduleProgrammingService } from './../services/schedule.service';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { QuickstartProgrammingService, QuickstartsContext } from '../../services/quickstart-programming.service';
import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';


@Component({
  selector: 'prg-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.less']
})
export class ScheduleListComponent extends BaseRoutingComponent {

  _schedules: Observable<Array<ScheduleEvent>>;
  initialized: Observable<boolean>;
  expanded: Observable<boolean>;
  _searchText: string;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected store: Store<{
      quickstartProgramming: QuickstartsContext,
      scheduleProgramming: ScheduleQuickstartContext
    }>,
    private shared: SharedProgrammingService
  ) {
    super();
    this._schedules = this.store.select(s => s.scheduleProgramming.scheduleEvents);
    this.initialized = this.store.select(s => s.scheduleProgramming.initialized);
    this.expanded = this.shared.listExpanded;
    this._searchText = '';
  }

  openSchedule(schedule: ScheduleEvent) {
    // NOTE in this context we want to go directly to the add route, if the same schedule is opened from the
    // my programming list we go to edit
    this.router.navigate(['when-then/device/100100/event', schedule.eventId, 'add'], { relativeTo: this.moduleRoot });
  }

  toggleExpand() {
    this.shared.toggleListExpanded();
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/schedule-list/schedule-list.component.ts